const LOAD_MORE_SELECTOR = '#LoadMoreProducts';
let isLoadingMore = false;
let infiniteObserver = null;
let infiniteScrollScrollBound = false;

async function loadMoreProducts(loadMoreBtn) {
  if (!loadMoreBtn || isLoadingMore) return;

  const nextUrl = loadMoreBtn.getAttribute('data-next-url');
  if (!nextUrl) {
    loadMoreBtn.remove();
    return;
  }

  if (!loadMoreBtn.dataset.originalText) {
    loadMoreBtn.dataset.originalText = loadMoreBtn.textContent.trim();
  }

  const originalText = loadMoreBtn.dataset.originalText;
  const loadingText = loadMoreBtn.dataset.loadingText || 'Loading...';
  const tryAgainText = loadMoreBtn.dataset.tryAgainText || 'Try again';

  isLoadingMore = true;
  loadMoreBtn.disabled = true;
  loadMoreBtn.textContent = loadingText;

  try {
    const response = await fetch(nextUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Network error');

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newSectionContainer =
      doc.querySelector('#ProductGridContainer') ||
      doc.querySelector('.template-search__results.collection') ||
      doc.querySelector('.collection') ||
      doc;

    let newGrid = newSectionContainer.querySelector('#product-grid') || newSectionContainer;

    let newListContainer;
    if (newGrid.tagName === 'UL') {
      newListContainer = newGrid;
    } else {
      newListContainer =
        newGrid.querySelector('ul.product-grid') ||
        newGrid.querySelector('ul.grid') ||
        newGrid;
    }

    const sectionContainer =
      loadMoreBtn.closest('#ProductGridContainer') ||
      loadMoreBtn.closest('.template-search__results.collection') ||
      loadMoreBtn.closest('.collection') ||
      document;

    let grid = sectionContainer.querySelector('#product-grid') || sectionContainer;

    let listContainer;
    if (grid.tagName === 'UL') {
      listContainer = grid;
    } else {
      listContainer =
        grid.querySelector('ul.product-grid') ||
        grid.querySelector('ul.grid') ||
        grid;
    }

    const newItems = newListContainer.querySelectorAll(':scope > li');
    newItems.forEach((item) => {
      listContainer.appendChild(item);
    });

    const newButton = newSectionContainer.querySelector(LOAD_MORE_SELECTOR);

    if (newButton && newButton.getAttribute('data-next-url')) {
      loadMoreBtn.setAttribute(
        'data-next-url',
        newButton.getAttribute('data-next-url')
      );
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = originalText;
    } else {
      loadMoreBtn.remove();
    }
  } catch (err) {
    console.error(err);
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = tryAgainText;
  } finally {
    isLoadingMore = false;
  }
}

document.addEventListener('click', (event) => {
  const loadMoreBtn = event.target.closest(LOAD_MORE_SELECTOR);
  if (!loadMoreBtn) return;

  event.preventDefault();
  loadMoreProducts(loadMoreBtn);
});

function initInfiniteScroll() {
  const loadMoreBtn = document.querySelector(LOAD_MORE_SELECTOR);
  if (!loadMoreBtn) return;

  const mode = loadMoreBtn.dataset.paginationMode || 'button';
  if (mode !== 'infinite') {
    return;
  }

  if (loadMoreBtn.dataset.infiniteInitialized === 'true') return;
  loadMoreBtn.dataset.infiniteInitialized = 'true';

  if ('IntersectionObserver' in window) {
    if (!infiniteObserver) {
      infiniteObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isLoadingMore) {
              loadMoreProducts(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0.1,
        }
      );
    }

    infiniteObserver.observe(loadMoreBtn);
  } else {
    if (!infiniteScrollScrollBound) {
      infiniteScrollScrollBound = true;

      window.addEventListener('scroll', () => {
        if (isLoadingMore) return;

        const btn = document.querySelector(LOAD_MORE_SELECTOR);
        if (!btn) return;

        const modeNow = btn.dataset.paginationMode || 'button';
        if (modeNow !== 'infinite') return;

        const rect = btn.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 300) {
          loadMoreProducts(btn);
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initInfiniteScroll();

  const mo = new MutationObserver(() => {
    initInfiniteScroll();
  });

  mo.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
